module.exports = __webpack_public_path__ + "static/img/green2.40d37bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green2.png
// module id = 8jrq
// module chunks = 1